import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  tag: '⚡ PRONTO IN 5 MIN',
  title: "Lezioni Pronte All'Uso",
  desc: 'Dalla Partita Doppia alla Seconda Prova, tutto strutturato per gli studenti ITE del Biennio e del Triennio. Apri il file e sei pronto.'
}, {
  tag: '📊 6 VOLUMI RISOLTI',
  title: 'Soluzionari Completi',
  desc: 'Ogni esercizio di contabilità, bilancio e finanza è già risolto e commentato passo passo. Risparmia ore di calcoli manuali.'
}, {
  tag: '🖥️ SLIDE LIM INCLUSE',
  title: 'Supporto Visivo per la LIM',
  desc: 'Slide grafiche ad alto impatto pronte da proiettare: schemi di Partita Doppia, mappe del Bilancio e percorsi visivi per la Gen Z.'
}, {
  tag: '🏛️ CONFORME MIM',
  title: "Metodologia d'Eccellenza",
  desc: 'Un sistema che garantisce la copertura completa del curricolo ministeriale con programmazione annuale, UDA e PECUP già integrati.'
}, {
  tag: '♿ DSA & BES',
  title: 'Didattica Inclusiva',
  desc: 'Materiali differenziati per livello Base, Intermedio e Avanzato con schede e PDP dedicati agli studenti DSA e BES già pronti.'
}, {
  tag: '✅ PRONTE DA STAMPARE',
  title: 'Verifiche & Griglie',
  desc: '35 griglie di valutazione e 25 verifiche sommative conformi alle linee guida MIM, compatibili con ClasseViva, Argo e Axios.'
}];
export function Benefits() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-23">
          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3" data-id="element-24">
            Tutto incluso nel Metodo
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-brand-cream mb-3 leading-tight" data-id="element-25">
            6 vantaggi concreti che{' '}
            <span className="bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-26">
              trasformano
            </span>{' '}
            il modo in cui prepari, insegni e valuti l'Economia Aziendale.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-4" data-id="element-27">
          {benefits.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-brand-card border border-brand-orange/20 p-6 sm:p-7 rounded-2xl hover:border-brand-orange/50 transition-all hover:-translate-y-1" data-id="element-28">
              <div className="inline-block bg-brand-orange/15 border border-brand-orange/30 text-brand-orange text-[10px] sm:text-xs font-black px-3 py-1 rounded-full mb-3 uppercase tracking-wider" data-id="element-29">
                {b.tag}
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-brand-cream mb-2" data-id="element-30">
                {b.title}
              </h3>
              <p className="text-gray-300 font-medium leading-relaxed text-sm sm:text-base" data-id="element-31">
                {b.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 text-center" data-id="element-32">
          <p className="text-brand-gold font-bold text-sm sm:text-base" data-id="element-33">
            + 4 Bonus esclusivi del valore di{' '}
            <span className="text-brand-cream font-black" data-id="element-34">€198</span> inclusi
          </p>
        </motion.div>
      </div>
    </section>;
}